<template>

  <v-list-item
      :class="isSelectedReceiver(receiver) ? 'selectedListItemColor' : ''"
      selectable
      @click="$emit('onSetSelectedReceiver',{receiver, index})"
  >
    <v-list-item-icon class="align-self-center">
      <v-icon>mdi-{{ receiver.groupId ? 'account-group' : 'account-circle' }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title class="d-flex"
      >
        <div>{{ receiver.name }}</div>
        <div v-if="!receiver.groupId && receiver.online && onlineDisplayIsEnabled" class="green online"></div
        >
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action>
      <v-menu v-if="receiver.groupId">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item v-if="receiver.groupId" link @click="$emit('displayGroupMembers',receiver)">
            <v-list-item-title>Mitglieder</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import NumberBadge from '@/components/decorators/NumberBadge.vue';
import messagingUtil from './messagingUtil';
import GroupMemberDialog from './GroupMemberDialog.vue';
import DeleteChatConfirmationDialog from './DeleteChatConfirmationDialog.vue';
import dateUtils from '@/common/dateUtils';

export default {
  mixins: [common, configMixin],
  name: 'Receiver',

  props: {
    receiver: Object,
    selectedReceiver: Object,
    index: Number
  },
  computed: {
    ...mapState('messaging', [
      'userId',
      'userById',
      'messages',
      'messagesByUserId',
      'messagesByGroupId',
      'messagesByUserIdUnreadCount',
      'messagesByGroupIdUnreadCount',
      'groupById',
      'dataLoaded',
      'users',
      'groups',
    ]),
    // display online bubble always except in production environments
    onlineDisplayIsEnabled() {
      if (this.$store.state.configs.stage !== 'prod') return true;
      return this.features.enableDisplayOfOnlineStateInMessaging || false;
    },

    selectedItemColor() {
      return this.theme.selectedItemColor;
    },

  },
  methods: {
    ...mapActions('messaging', ['deleteChat']),

    isSelectedReceiver(receiver) {

      return this.selectedReceiver &&
          ((this.selectedReceiver.userId && this.selectedReceiver.userId === receiver.userId) ||
              (this.selectedReceiver.groupId && this.selectedReceiver.groupId === receiver.groupId))
    },

  },

};
</script>
<style scoped>
.selected {
  border: 1px solid red;
  background: #f0f0f0;
}

.online {
  margin-left: 8px;
  width: 10px;
  height: 10px;
  border-radius: 4px;
}
</style>
